import { render, staticRenderFns } from "./bidderProjectWorkflow.vue?vue&type=template&id=5da5b1d3&scoped=true"
import script from "./bidderProjectWorkflow.vue?vue&type=script&lang=js"
export * from "./bidderProjectWorkflow.vue?vue&type=script&lang=js"
import style0 from "./bidderProjectWorkflow.vue?vue&type=style&index=0&id=5da5b1d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5b1d3",
  null
  
)

export default component.exports